import http from "@/common/http.service";
import { getApiBaseUrl } from "@/common/http.header";
const GET_WEBFORM = "form-dropdown";
const GET_LIST = "list/lookup";
const GET_CAMPAIGN = "automation/campaign/list";
const GET_CONTACT_PROPERTY = "fields/list";
const GET_TIMEZONE = "profile/timezone";
const GET_TAGS_URL = "campaign/get-tags";
const GET_CONTACT_URL = "panel/contact/search";
const GET_SENDER_URL = "campaign/get-sender";
const GET_SEGMENT = "campaign/segment-list";
const TRACKING_URL = "campaign/conversion_tracking_codes";
const POST_AUTOMATION_CREATE = "panel/advanced-automation";
const AUTOMATION_DROPDOWN_LIST = "panel/advanced-automation/drowpdown-list";
const COUNTRY_URL = "profile/country";
const GET_TAX_COUNTRY_LIST = "getTaxCountryList";
const FREQUENCY_CAP = "panel/frequencycapping/save";
const GET_ACCOUNT_PREFERENCES = "panel/account/preferences";
const GET_SCHEDULELE_DATA = "campaign/get-schedule-data";
const ALLOW_DUPLICATE_CONTACTS = "panel/allow-duplicate-contacts/save";
export const createAutomation = (params) => {
  return http.post(POST_AUTOMATION_CREATE, params);
};
export const getWebform = (params) => {
  return http.post(GET_WEBFORM, params);
};

export const getListlist = (params) => {
  return http.post(GET_LIST, params);
};

export const getSegmentlist = (params) => {
  return http.post(GET_SEGMENT, params);
};

export const getCampaignlist = (params) => {
  return http.post(GET_CAMPAIGN, params);
};

export const getContactProperty = (params) => {
  return http.post(GET_CONTACT_PROPERTY, params);
};

export const getTimezone = () => {
  return http.get(GET_TIMEZONE);
};

export const fetchTags = (params) => {
  return http.post(GET_TAGS_URL, params);
};

export const fetchContacts = (params) => {
  return http.post(GET_CONTACT_URL, params);
};

export const fetchSender = (params) => {
  return http.post(GET_SENDER_URL, params);
};

export const fetchTrackingCodes = () => {
  return http.get(TRACKING_URL);
};

export const fetchAutomationListForDropdown = (params) => {
  return http.post(AUTOMATION_DROPDOWN_LIST, params);
};

export const fetchCountryList = () => {
  return http.get(COUNTRY_URL);
};

export const fetchTaxList = () => {
  return http.get(GET_TAX_COUNTRY_LIST, "", getApiBaseUrl());
};

export const changeFrequencyCap = (params) => {
  return http.post(FREQUENCY_CAP, params, null, null, "v2");
};

export const changeAllowDuplicateContacts = (params) => {
  return http.post(ALLOW_DUPLICATE_CONTACTS, params, null, null, "v2");
};

export const getAccountPreferences = () => {
  return http.get(GET_ACCOUNT_PREFERENCES, "", "", "v2");
};

export const fetchCurrentTime = (id) => {
  return http.post(GET_SCHEDULELE_DATA, { id });
};
